import React, { forwardRef, Fragment, useState, useEffect } from "react";
import { Checkbox, Row, Col, Typography } from 'antd';
import TranslatedText from "translations/TranslatedText";
import URLConfig from './URLConfig';

export default forwardRef((props: any, ref: any) => {
  const {
    toolConfig,
    ...rest
  } = props;
  const { slideOnCheckAnswer } = toolConfig;

  const setSlideAfterAnswer = (event) => {
    console.log('todo - implement me');
  }

  return (
    <Fragment>
      <Row type="flex" justify="space-between" align="middle">
        <Col>
          <Typography>
            <TranslatedText id="settings.form.imageslideshow.input.label" />
          </Typography>
        </Col>
        {
          // todo - implement me
          // <Col>
          //   <TranslatedText id="settings.form.imageslideshow.config.advanceafter" />
          // </Col>
        }
      </Row>
      <Row type="flex" justify="space-between" align="middle">
        <Col>
          <URLConfig {...rest} />
        </Col>
        {
          // todo - implement me
          // <Col>
          //   <Checkbox checked={slideOnCheckAnswer} onChange={setSlideAfterAnswer} />
          // </Col>
        }
      </Row>
    </Fragment>
  );
});
